import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  // 定义状态
  state:{
    //存放组件之间共享的数据
    name:"xiaolu",
    password:'123456',
    openid: '',
    token:'',
    farmInfo:{},
    userInfo:{},
    count:0,
    loading: 0,
    goodsScrollTop: 0,
    addressParams:{},
    userFlag:false
},
 mutations:{
     //显式的更改state里的数据
     change:function(state,obj){
         console.log()
     },
    //  根据默认地址获取农场ID
     farmInfo:function(state,data){
        state.farmInfo = data;
        console.log(state)
    },
    // 获取openId
    setOpenid:function(state,data){
        state.openid = data;
    },
    // 购物车数量；
    carCount:function(state,data){
       state.count = data;
    },
    homeSetCarCount: function(state,data) {
        state.count = data.goodsNo
        // 本地；
        localStorage.setItem('goodsNo',data.goodsNo);
    },
    goodsScrollTop: function(state,data) {
        state.goodsScrollTop = data
        console.log(state.goodsScrollTop)
    },
    defalutAddress: function(state,data){
        state.defalutAddressId = data.id
    },
    changeLoading: function (state,data) {
        state.loading = data
    },
    // 保存增加地址的数据；
    setAddressData:function(state,data){
        state.addressParams = data
    },
    shangeUserFlag:function(state,data){
        state.userFlag = data
    }

 },
 getters:{
    getOpenId:function(state){
        return state.openid;
    },
     //获取数据的方法
     getName:function(state){
         return state.name;
     },
    //根据默认地址获取农场信息
     getFarmInfo:function(state){
         return state.farmInfo
     },
     getCarCount: function (state) {
         return state.count
     },
     //获取用户信息；ID
     userInfo:function(state){
         return state.userInfo
     },
     changeAsync:function(){},
     getAddressId: function(state){
        return state.defalutAddressId
     },
     // 获取loading值
     getLoading (state) {
        return state.loading
     },
    //  获取地址数据；
    getAddressData(state){
        return state.addressParams
    },
    getGoodsScrollTop (state) {
        console.log(state)
        return state.goodsScrollTop
    }
 },
 actions:{
     //通过mutations中的函数将数据传到state中是异步操作； //修改state中数据的逻辑；
     add:function(context,value){
        setTimeout(function(){
　　　　　　　　　　　//提交事件
           context.commit('changeAsync',value);
        },1000)
        
    },
    setOpenid: function(val){
      commit('setOpenid', val)
    },
    changeLoading: function (val) {
      commit('changeLoading',val)
    }
 }
})

export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js